// i18n dictionary FR/EN for ARVEN Cuisines
export const i18n = {
  fr: {
    nav: {
      home: "Accueil",
      collections: "Collections",
      projects: "Réalisations",
      materials: "Matériaux",
      savoir: "Savoir-faire",
      pros: "Professionnels",
      contact: "Contact",
      cta: "Prendre rendez-vous",
      tagline: "L'art de concevoir votre quotidien",
    },
    common: {
      discover: "Découvrir",
      discoverMore: "Découvrir la collection",
      learnMore: "En savoir plus",
      contact: "Nous contacter",
      appointment: "Prendre rendez-vous",
      partner: "Devenir partenaire",
      sending: "Envoi...",
      sent: "Votre demande a bien été envoyée.",
      error: "Une erreur est survenue. Veuillez réessayer.",
      back: "Retour",
      next: "Suivant",
      finish: "Confirmer",
      all: "Tout",
      cuisines: "Cuisines",
      bains: "Salles de bain",
      dressings: "Dressings",
      spaces: "Espaces de vie",
    },
    home: {
      hero_h1: "L'art de concevoir\nvotre quotidien.",
      hero_sub: "Des cuisines sur-mesure pensées pour durer, conçues pour s'intégrer parfaitement à votre manière de vivre.",
      hero_cta1: "Découvrir les collections",
      hero_cta2: "Prendre rendez-vous",
      positioning_eyebrow: "Notre positionnement",
      positioning_h2: "Une approche plus exigeante\nde la cuisine.",
      positioning_p: "Chez ARVÈN, nous concevons des cuisines où esthétique, fonctionnalité et précision technique coexistent naturellement. Chaque projet est pensé comme un espace architectural à part entière. Pas comme un simple assemblage de meubles.",
      positioning_p2: "Nous travaillons avec des matières durables, des finitions premium et une approche sur mesure adaptée autant aux particuliers exigeants qu'aux professionnels de l'agencement.",
      pillars_eyebrow: "Notre philosophie",
      pillar1_title: "Design intemporel",
      pillar1_desc: "Des lignes sobres et architecturales pensées pour traverser les années.",
      pillar2_title: "Fonctionnalité réelle",
      pillar2_desc: "Chaque détail est conçu pour améliorer l'usage quotidien.",
      pillar3_title: "Fabrication maitrisée",
      pillar3_desc: "Des standards de fabrication élevés et des matières sélectionnées avec exigence.",
      collections_eyebrow: "Collections",
      collections_h2: "Quatre univers,\nune même exigence.",
      b2b_eyebrow: "B2B",
      b2b_h2: "Pensé aussi pour les professionnels.",
      b2b_p: "ARVÈN accompagne les agenceurs, architectes, cuisinistes et showrooms souhaitant proposer une gamme premium différenciante. Personnalisation, qualité perçue élevée, flexibilité et accompagnement projet.",
      reassurance_eyebrow: "Notre engagement",
      reassurance: [
        "Sur-mesure intégral",
        "Fabrication européenne",
        "Accompagnement projet",
        "Matières premium",
        "Livraison maitrisée",
        "Solutions pour professionnels",
      ],
      cta_h2: "Parlons de votre projet.",
      cta_p: "Réservez un moment privilégié avec notre équipe pour explorer ensemble les possibilités de votre espace.",
      direct_eyebrow: "Notre modèle",
      direct_h2: "Fabricant direct d’usine,\nsans intermédiaire.",
      direct_p: "ARVÈN Cuisines est importateur et distributeur direct depuis nos ateliers partenaires en Roumanie. Une qualité fabriquée aux normes européennes, livrée directement en Suisse Romande et en France. Résultat : des cuisines premium, sur-mesure, à des prix inégalés sur le marché.",
      direct_pillars: [
        { t: "Direct usine", d: "Importation directe depuis nos ateliers en Roumanie, sans intermédiaire." },
        { t: "Normes européennes", d: "Fabrication contrôlée aux standards qualité européens les plus exigeants." },
        { t: "Prix concurrentiels", d: "Une intégration verticale qui se traduit par des tarifs imbattables à qualité égale." },
        { t: "Chantier clé en main", d: "Pose, suivi et coordination des artisans (carreleur, plombier, électricien, menuisier) inclus." },
      ],
      zones_eyebrow: "Zones d’intervention",
      zones_h2: "Suisse Romande,\nlivraison France via revendeurs.",
      zones_p: "Nous prenons en charge l’intégralité du chantier en Suisse Romande. En France, nous distribuons exclusivement via un réseau de revendeurs et d’agenceurs partenaires.",
      zones_cities: ["Genève", "Lausanne", "Yverdon-les-Bains", "Fribourg", "Neuchâtel", "Montreux", "Nendaz", "Crans-Montana"],
      zones_france: "France — distribution via revendeurs partenaires",
    },
    collections: {
      hero_h1: "Des collections pensées\ncomme des espaces de vie.",
      hero_sub: "Quatre univers, chacun guidé par une intention claire : sublimer la matière, la lumière et l'usage.",
      eyebrow: "Collection",
      cta_h2: "Un projet en tête ?\nParlons-en ensemble.",
    },
    projects: {
      hero_h1: "Nos réalisations.",
      hero_sub: "Chaque projet est une rencontre entre vos envies et notre savoir-faire.",
      filters: {
        all: "Tout",
        cuisine: "Cuisines",
        bain: "Salles de bain",
        dressing: "Dressings",
        espace: "Espaces de vie",
      },
      detail: {
        back: "Retour aux réalisations",
        city: "Lieu",
        year: "Année",
        collection: "Collection",
        surface: "Surface",
        materials: "Matériaux",
        style: "Style",
      },
      cta: "Inspirez-vous, imaginez votre projet.",
    },
    materials: {
      hero_h1: "Matières d'exception.",
      hero_sub: "Des matières nobles sélectionnées avec exigence pour leur beauté et leur durabilité.",
      advantages: "Avantages",
      cta: "Un matériau, une émotion, une signature.",
    },
    savoir: {
      hero_h1: "Une exigence visible\ndans chaque détail.",
      hero_sub: "De la conception au montage, chaque étape est menée dans la même régle de l'art.",
      philosophy_eyebrow: "Notre philosophie",
      philosophy_h2: "Au-delà de la cuisine,\nl'architecture du quotidien.",
      philosophy_p: "ARVÈN est né d'une intuition : la cuisine est devenue le coeur architectural du foyer. Nous concevons des espaces qui dialoguent avec l'architecture existante, qui durent et qui se patinent avec grâce.",
      process_eyebrow: "Notre procédé",
      stats: [
        { value: "15+", label: "années d'expérience" },
        { value: "350+", label: "projets réalisés" },
        { value: "98%", label: "clients satisfaits" },
        { value: "100%", label: "sur-mesure" },
      ],
      steps: [
        { t: "Conception", d: "Plans architecturaux, simulations 3D, choix des matériaux en showroom." },
        { t: "Fabrication", d: "Ateliers européens partenaires, controle qualité à chaque étape." },
        { t: "Personnalisation", d: "Adaptations dimensionnelles, finitions sur-mesure, quincaillerie créée." },
        { t: "Accompagnement", d: "Suivi de projet dédié du devis à la pose finale." },
      ],
    },
    pros: {
      hero_h1: "Une marque pensée pour\nles professionnels exigeants.",
      hero_sub: "ARVÈN accompagne architectes, agenceurs, cuisinistes et showrooms en Suisse et en France.",
      why_eyebrow: "Pourquoi ARVÈN ?",
      why_h2: "Une proposition de valeur différenciante.",
      values: [
        { t: "Qualité perçue forte", d: "Des produits qui s'imposent visuellement en showroom et en projet." },
        { t: "Différenciation", d: "Une signature design qui sort du catalogue conventionnel." },
        { t: "Flexibilité", d: "Personnalisation dimensionnelle et de finitions sans contraintes industrielles." },
        { t: "Accompagnement", d: "Un interlocuteur dédié, des outils projet et du support commercial." },
        { t: "Marge premium", d: "Un positionnement haut de gamme structurellement margeable." },
        { t: "Logistique maitrisée", d: "Livraison et installation organisées de bout en bout." },
      ],
      audience_eyebrow: "Pour qui ?",
      audience_h2: "Une marque pour les acteurs exigeants.",
      audiences: ["Cuisinistes indépendants", "Agenceurs", "Architectes d'intérieur", "Promoteurs immobiliers", "Décorateurs", "Showrooms premium"],
      cta_h2: "Construisons une collaboration\nà votre image.",
      cta_btn: "Demander une présentation",
    },
    contact: {
      hero_h1: "Parlons de votre projet.",
      hero_sub: "Un projet, une question ? Nous sommes à votre écoute.",
      address_label: "Adresse",
      phone_label: "Téléphone",
      email_label: "Email",
      hours_label: "Horaires",
      hours_value: "Lundi – Vendredi\n9h00 – 18h00",
      form: {
        firstName: "Prénom",
        lastName: "Nom",
        email: "Email",
        phone: "Téléphone",
        type: "Type de projet",
        types: ["Particulier - Cuisine", "Particulier - Rénovation complète", "Professionnel - Revendeur", "Professionnel - Architecte"],
        budget: "Budget estimé",
        budgets: ["< 30 000 €", "30 000 – 60 000 €", "60 000 – 100 000 €", "> 100 000 €", "À définir"],
        city: "Ville",
        message: "Votre message",
        inspiration: "Lien d'inspiration (optionnel)",
        submit: "Envoyer le message",
      },
    },
    appointment: {
      hero_h1: "Prenez rendez-vous.",
      hero_sub: "Réservez un moment privilégié avec notre équipe pour échanger sur votre projet.",
      step1: "Vos informations",
      step2: "Votre projet",
      step3: "Choisissez une date",
      step4: "Choisissez un créneau",
      step5: "Confirmation",
      confirm_h2: "Demande confirmée.",
      confirm_p: "Nous vous recontacterons sous 24h pour valider votre rendez-vous.",
      newRequest: "Nouvelle demande",
    },
    footer: {
      tagline: "L'art de concevoir votre quotidien.",
      cols: { brand: "Maison", pages: "Navigation", contact: "Contact", legal: "Mentions" },
      legal_items: ["Mentions légales", "Confidentialité", "Cookies"],
      rights: "ARVÈN Cuisines — Tous droits réservés.",
      signature: "Suisse Romande & France",
    },
  },
  en: {
    nav: {
      home: "Home",
      collections: "Collections",
      projects: "Projects",
      materials: "Materials",
      savoir: "Craft",
      pros: "Professionals",
      contact: "Contact",
      cta: "Book an appointment",
      tagline: "The art of designing your everyday",
    },
    common: {
      discover: "Discover",
      discoverMore: "Discover the collection",
      learnMore: "Learn more",
      contact: "Contact us",
      appointment: "Book an appointment",
      partner: "Become a partner",
      sending: "Sending...",
      sent: "Your request has been sent.",
      error: "Something went wrong. Please try again.",
      back: "Back",
      next: "Next",
      finish: "Confirm",
      all: "All",
      cuisines: "Kitchens",
      bains: "Bathrooms",
      dressings: "Dressing rooms",
      spaces: "Living spaces",
    },
    home: {
      hero_h1: "The art of designing\nyour everyday.",
      hero_sub: "Bespoke kitchens designed to last, made to integrate seamlessly into your way of living.",
      hero_cta1: "Discover collections",
      hero_cta2: "Book an appointment",
      positioning_eyebrow: "Our positioning",
      positioning_h2: "A more demanding approach\nto the kitchen.",
      positioning_p: "At ARVEN, we design kitchens where aesthetics, function and technical precision naturally coexist. Each project is conceived as an architectural space in its own right. Not a mere assembly of cabinets.",
      positioning_p2: "We work with durable materials, premium finishes and a bespoke approach suited to discerning individuals and seasoned design professionals alike.",
      pillars_eyebrow: "Our philosophy",
      pillar1_title: "Timeless design",
      pillar1_desc: "Sober, architectural lines designed to last through the years.",
      pillar2_title: "Real functionality",
      pillar2_desc: "Every detail is conceived to enhance daily use.",
      pillar3_title: "Mastered craft",
      pillar3_desc: "Elevated manufacturing standards and rigorously selected materials.",
      collections_eyebrow: "Collections",
      collections_h2: "Four universes,\none same standard.",
      b2b_eyebrow: "B2B",
      b2b_h2: "Designed for professionals too.",
      b2b_p: "ARVEN supports designers, architects, kitchen specialists and showrooms wishing to offer a distinctive premium range. Customization, perceived quality, flexibility and project support.",
      reassurance_eyebrow: "Our commitment",
      reassurance: ["Full bespoke", "European craft", "Project support", "Premium materials", "Controlled delivery", "B2B solutions"],
      cta_h2: "Let's talk about your project.",
      cta_p: "Book a privileged moment with our team to explore the possibilities of your space together.",
      direct_eyebrow: "Our model",
      direct_h2: "Factory-direct manufacturer,\nno middleman.",
      direct_p: "ARVÈN Cuisines is a direct importer and distributor from our partner workshops in Romania. Quality manufactured to European standards, delivered directly to French-speaking Switzerland and France. The result: premium custom kitchens at prices unmatched on the market.",
      direct_pillars: [
        { t: "Factory direct", d: "Direct import from our Romania workshops, with no middleman." },
        { t: "European standards", d: "Manufacturing controlled to the strictest European quality standards." },
        { t: "Competitive pricing", d: "Vertical integration translates into unbeatable rates for equivalent quality." },
        { t: "Turnkey site", d: "Installation, project management and trades coordination (tiler, plumber, electrician, joiner) included." },
      ],
      zones_eyebrow: "Areas served",
      zones_h2: "French-speaking Switzerland,\nFrance via partner resellers.",
      zones_p: "We handle the entire project on site in French-speaking Switzerland. In France, we distribute exclusively through a network of partner resellers and interior designers.",
      zones_cities: ["Geneva", "Lausanne", "Yverdon-les-Bains", "Fribourg", "Neuchâtel", "Montreux", "Nendaz", "Crans-Montana"],
      zones_france: "France — distribution via partner resellers",
    },
    collections: {
      hero_h1: "Collections designed\nas living spaces.",
      hero_sub: "Four universes, each guided by a clear intention: to elevate material, light and use.",
      eyebrow: "Collection",
      cta_h2: "A project in mind?\nLet's discuss it together.",
    },
    projects: {
      hero_h1: "Our projects.",
      hero_sub: "Every project is a meeting between your aspirations and our craft.",
      filters: { all: "All", cuisine: "Kitchens", bain: "Bathrooms", dressing: "Dressing rooms", espace: "Living spaces" },
      detail: { back: "Back to projects", city: "Location", year: "Year", collection: "Collection", surface: "Surface", materials: "Materials", style: "Style" },
      cta: "Get inspired. Imagine your project.",
    },
    materials: {
      hero_h1: "Exceptional materials.",
      hero_sub: "Noble materials selected with rigour for their beauty and durability.",
      advantages: "Advantages",
      cta: "A material, an emotion, a signature.",
    },
    savoir: {
      hero_h1: "A rigour visible\nin every detail.",
      hero_sub: "From design to installation, every step follows the same craft principles.",
      philosophy_eyebrow: "Our philosophy",
      philosophy_h2: "Beyond the kitchen,\nthe architecture of everyday life.",
      philosophy_p: "ARVEN was born from an intuition: the kitchen has become the architectural heart of the home. We design spaces that dialogue with the existing architecture, that endure and gracefully patinate.",
      process_eyebrow: "Our process",
      stats: [
        { value: "15+", label: "years of expertise" },
        { value: "350+", label: "projects delivered" },
        { value: "98%", label: "satisfied clients" },
        { value: "100%", label: "bespoke" },
      ],
      steps: [
        { t: "Design", d: "Architectural plans, 3D simulations, material choices in our showroom." },
        { t: "Craft", d: "European workshop partners, quality control at every stage." },
        { t: "Customization", d: "Dimensional adaptations, bespoke finishes, designed hardware." },
        { t: "Support", d: "Dedicated project lead from quote to final installation." },
      ],
    },
    pros: {
      hero_h1: "A brand built for\ndemanding professionals.",
      hero_sub: "ARVEN partners with architects, designers, kitchen specialists and showrooms across Switzerland and France.",
      why_eyebrow: "Why ARVEN?",
      why_h2: "A distinctive value proposition.",
      values: [
        { t: "Strong perceived quality", d: "Products that visually stand out in showrooms and projects." },
        { t: "Differentiation", d: "A design signature that stands apart from conventional catalogues." },
        { t: "Flexibility", d: "Dimensional and finish customization without industrial constraints." },
        { t: "Support", d: "A dedicated contact, project tools and commercial support." },
        { t: "Premium margin", d: "A structurally marginable high-end positioning." },
        { t: "Controlled logistics", d: "Delivery and installation orchestrated end to end." },
      ],
      audience_eyebrow: "For whom?",
      audience_h2: "A brand for demanding actors.",
      audiences: ["Independent kitchen retailers", "Designers", "Interior architects", "Real estate developers", "Decorators", "Premium showrooms"],
      cta_h2: "Let's build a partnership\nthat fits your identity.",
      cta_btn: "Request a presentation",
    },
    contact: {
      hero_h1: "Let's talk about your project.",
      hero_sub: "A project, a question? We are here to listen.",
      address_label: "Address",
      phone_label: "Phone",
      email_label: "Email",
      hours_label: "Hours",
      hours_value: "Monday – Friday\n9:00 – 18:00",
      form: {
        firstName: "First name",
        lastName: "Last name",
        email: "Email",
        phone: "Phone",
        type: "Project type",
        types: ["Private — Kitchen", "Private — Full renovation", "Professional — Retailer", "Professional — Architect"],
        budget: "Estimated budget",
        budgets: ["< 30,000 €", "30,000 – 60,000 €", "60,000 – 100,000 €", "> 100,000 €", "TBD"],
        city: "City",
        message: "Your message",
        inspiration: "Inspiration link (optional)",
        submit: "Send message",
      },
    },
    appointment: {
      hero_h1: "Book an appointment.",
      hero_sub: "Book a privileged moment with our team to discuss your project.",
      step1: "Your information",
      step2: "Your project",
      step3: "Pick a date",
      step4: "Pick a time slot",
      step5: "Confirmation",
      confirm_h2: "Request confirmed.",
      confirm_p: "We will be in touch within 24 hours to validate your appointment.",
      newRequest: "New request",
    },
    footer: {
      tagline: "The art of designing your everyday.",
      cols: { brand: "House", pages: "Navigation", contact: "Contact", legal: "Legal" },
      legal_items: ["Legal notice", "Privacy", "Cookies"],
      rights: "ARVÈN Cuisines — All rights reserved.",
      signature: "French-speaking Switzerland & France",
    },
  },
};
